import { lazyPage } from '../../utils/lazyPage';

export const QuizHub = lazyPage(() => import('./QuizHub'));
export const BettorTypeQuiz = lazyPage(() => import('./bettor-type/BettorTypeQuiz'));
export const BettorTypeResult = lazyPage(() => import('./bettor-type/BettorTypeResult'));
